import { Typography, styled } from '@mui/material';
import { FC, ReactNode } from 'react';

const StyledCard = styled('li')`
  display: grid;
  /* minmax(0, 1fr) lets the column shrink below its content width so noWrap children ellipsize. */
  grid-template-columns: minmax(0, 1fr);
  text-align: center;
  padding: 0.75rem;
  row-gap: 0.5rem;
  border-radius: 4px;
  border: 2px solid var(--White, #fff);
  background: radial-gradient(
    227.68% 141.42% at 0% 0%,
    rgba(249, 250, 250, 0.8) 0%,
    rgba(255, 255, 255, 0.32) 100%
  );
  /* card shadow */
  box-shadow:
    0px 24px 48px 0px rgba(75, 82, 93, 0.02),
    0px 4px 24px 0px rgba(16, 37, 62, 0.04),
    0px -4px 40px 0px rgba(255, 255, 255, 0.06);
`;

const ValueRow = styled('div')`
  align-items: center;
  display: flex;
  gap: 0.375rem;
  justify-content: center;
  min-width: 0;
`;

interface IDataCardProps {
  title: string;
  formattedValue: string;
  valueTooltip?: string;
  /** Rendered beside the value — e.g. a return percentage next to an unrealised gain. */
  valueAdornment?: ReactNode;
}

export const DataCard: FC<IDataCardProps> = ({
  title,
  formattedValue: value,
  valueTooltip,
  valueAdornment,
}) => {
  return (
    <StyledCard>
      <Typography variant='caption' color='text.secondary' noWrap component='label' title={title}>
        {title}
      </Typography>
      <ValueRow>
        <Typography color='text.primary' noWrap title={valueTooltip ?? value}>
          {value}
        </Typography>
        {valueAdornment}
      </ValueRow>
    </StyledCard>
  );
};
